import React from 'react';
import { Card, Text, useMantineTheme, SimpleGrid } from '@mantine/core';

import { safeValue, sqlDateToHumanDate } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

const GaransiStep2Card = ({
    stateData,
    stateSortList,
    stateSortSelected,
    fnSort,
    fnSelectedData
}) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>

            <SortSegmentedControl
                stateSortList={stateSortList}
                stateSortSelected={stateSortSelected}
                fnSort={fnSort}
                stateStyle={{ marginBottom: theme.spacing.md }}
            />

            <SimpleGrid
                cols={1}
                spacing='md'
                breakpoints={[
                    { minWidth: 'xl', cols: 3, spacing: 'md' },
                    { minWidth: 'lg', cols: 2, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 2, spacing: 'md' },
                ]}
            >
                {Object.keys(stateData).map((key, index) => {
                    return (
                        <Card
                            key={key}
                            shadow=''
                            radius="md"
                            withBorder={true}

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                                cursor: 'pointer',
                            }}

                            onClick={() => {
                                fnSelectedData(stateData[key]);
                            }}
                        >
                            <Card.Section p='sm'>
                                <Text size="sm">
                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Item'
                                        stateContent={
                                            <React.Fragment>
                                                <Text>{safeValue(stateData[key].stock_category_name, ' - ')}</Text>
                                                <Text>{safeValue(stateData[key].stock_category_sub_name, ' - ')}</Text>
                                                <Text>{safeValue(stateData[key].stock_serial_number, '')}</Text>
                                            </React.Fragment>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.supplierName.caption}
                                        stateContent={safeValue(stateData[key].supplier_name, '-')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Jumlah'
                                        stateContent={safeValue(stateData[key].jumlah_detil, '')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Tanggal Pengajuan'
                                        stateContent={sqlDateToHumanDate({
                                            stateDate: stateData[key].stock_garansi_tanggal_pengajuan,
                                            stateWithTime: false,
                                            stateLang: 'id',
                                            stateIsShort: false,
                                            stateDay: false,
                                            stateDefaultValue: ' - ',
                                            stateDateType: 'day'
                                        })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Keterangan'
                                        stateContent={<Text lineClamp={2}>{safeValue(stateData[key].stock_garansi_info, '-')}</Text>}
                                        stateDivider={false}
                                    />
                                </Text>
                            </Card.Section>
                        </Card>
                    )
                })}
            </SimpleGrid>
        </React.Fragment>
    )
}

export default React.memo(GaransiStep2Card);